// utils/openPatientTab.jsx

/**
 * Opens a new tab with the patient-view route
 * and passes the patientId via localStorage to sessionStorage.
 *
 * @param {string} patientId - The ID of the patient to open in a new tab.
 */
export const openPatientInNewTab = (patientId) => {
  // Store patientId temporarily in localStorage
  localStorage.setItem("TEMP_PATIENT_ID", patientId);

  // Open new tab
  window.open("/patient-view?isnewtab=true", "_blank");
};

export const removeTempPatientId = () => {
  localStorage.removeItem("TEMP_PATIENT_ID");
};
